export const DEFAULT_HEADING        =   'Lorem ipsum dolor sit amet';
export const DEFAULT_SUBHEADING     =   'We’re looking for great people to join our growing team.';
export const INITIAL_VALUES         =   {
                                            search_text: '',
                                            location_text:'',
                                            job_type:'',
                                            remote: false
                                        };
